export const services = [
    {
      name: "Hem_without_Horse_Hair",
      price: ["40", "60", "80"],
    },
    {
      name: "Hem_Sleeves",
      price: ["20", "40", "80"],
    },
    {
      name: "Take_in_Bust",
      price: ["40", "60", "80"],
    },
    {
      name: "Take_in_Back",
      price: ["40", "60", "80"],
    },
    {
      name: "Take_in_Sides",
      price: ["40", "80", "120"],
    },
    {
      name: "Take_in_Sides_Beads",
      price: ["80", "120", "180"],
    },
    {
      name: "Take_in_Shoulders",
      price: ["30", "50", "70"],
    },
    {
      name: "Take_in_Sleeves",
      price: ["20", "40", "60"],
    },
    {
      name: "Take_in_Straps",
      price: ["20", "40", "60"],
    },

    {
      name: "Open_Neck",
      price: ["30", "50", "70"],
    },
    {
      name: "Cover_Bust",
      price: ["40", "60", "80"],
    },
    {
      name: "Cover_Slit",
      price: ["20", "40", "60"],
    },
    {
      name: "Shoulder_Pads",
      price: ["25", "35", "40"],
    },
    {
      name: "Pads",
      price: ["15", "25", "45"],
    },
    {
      name: "Change_Zipper",
      price: ["40", "60", "90"],
    },
    {
      name: "Customizing_Shoulder_Design",
      price: ["60", "150", "250"],
    },
    {
      name: "Hem_with_Horse_Hair",
      price: ["60", "90", "120"],
    },
    {
      name: "Take_in_Back_Zipper",
      price: ["40", "60", "90"],
    },
    {
      name: "Customizing",
      price: ["300", "500", "1000"],
    },
    {
      name: "American Bustle",
      price: ["20", "25", "40"],
    },
    {
      name: "French Bustle",
      price: ["20", "25", "40"],
    },
  ];